import Container from '@ui/container/container';

const TableListDenseSkeletonLoader = () => {
  const tableHead = () => {
    return (
      <Container className="flex fd-row" height="64px" width="997px">
        {/* checkbox */}
        <Container
          height="64px"
          width="50px"
          skLoader={{
            height: 22,
            width: 22,
            radius: 8,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />

        {/* full name */}
        <Container
          className="margin-r-76"
          height="64px"
          width="100px"
          skLoader={{
            height: 22,
            width: 100,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />

        {/* source */}
        <Container
          height="64px"
          width="92px"
          skLoader={{
            height: 22,
            width: 80,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
        {/* reg date */}
        <Container
          height="64px"
          width="132px"
          skLoader={{
            height: 22,
            width: 120,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
        {/* last login */}
        <Container
          height="64px"
          width="132px"
          skLoader={{
            height: 22,
            width: 120,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
        {/* watchtime */}
        <Container
          height="64px"
          width="120px"
          skLoader={{
            height: 22,
            width: 104,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
        {/* star score */}
        <Container
          height="64px"
          width="80px"
          skLoader={{
            height: 22,
            width: 80,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
      </Container>
    );
  };

  const tableRow = (idx: number) => {
    return (
      <Container
        key={idx}
        className="flex fd-row"
        height="64px"
        width="997px"
        style={{ borderTop: '1px solid var(--gray-700)' }}
      >
        {/* checkbox */}
        <Container
          height="64px"
          width="50px"
          skLoader={{
            height: 22,
            width: 22,
            radius: 8,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />

        {/* full name */}
        <Container className="flex fd-row ai-center" height="64px" width="176px">
          <Container
            className="margin-r-6"
            height="64px"
            width="32px"
            skLoader={{
              height: 32,
              width: 32,
              radius: 100,
              loading: true,
              design: 'GlobalCont1',
              justify: 'flex-start',
            }}
          />
          <Container className="flex fd-column" height="32px">
            <Container
              height="16px"
              width="120px"
              skLoader={{
                height: 12,
                width: 120,
                radius: 4,
                loading: true,
                design: 'GlobalCont1',
                justify: 'flex-start',
              }}
            />
            <Container
              height="16px"
              width="120px"
              skLoader={{
                height: 12,
                width: 120,
                radius: 4,
                loading: true,
                design: 'GlobalCont1',
                justify: 'flex-start',
              }}
            />
          </Container>
        </Container>

        {/* source */}
        <Container
          height="64px"
          width="92px"
          skLoader={{
            height: 22,
            width: 80,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
        {/* reg date */}
        <Container
          height="64px"
          width="132px"
          skLoader={{
            height: 22,
            width: 120,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
        {/* last login */}
        <Container
          height="64px"
          width="132px"
          skLoader={{
            height: 22,
            width: 120,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
        {/* watchtime */}
        <Container
          height="64px"
          width="120px"
          skLoader={{
            height: 22,
            width: 104,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
        {/* star score */}
        <Container
          height="64px"
          width="20px"
          skLoader={{
            height: 16,
            width: 16,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
        <Container
          height="64px"
          width="92px"
          skLoader={{
            height: 16,
            width: 32,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
        {/* lists */}
        <Container
          height="64px"
          width="138px"
          skLoader={{
            height: 22,
            width: 130,
            radius: 4,
            loading: true,
            design: 'GlobalCont1',
            justify: 'flex-start',
          }}
        />
      </Container>
    );
  };

  const pagingRow = () => {
    return (
      <Container className="flex fd-row gap-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <Container
            key={i}
            height="64px"
            width="32px"
            skLoader={{
              height: 32,
              width: 32,
              radius: 100,
              loading: true,
              design: 'GlobalCont1',
            }}
          />
        ))}
      </Container>
    );
  };

  return (
    <Container className="flex fd-column">
      <Container className="flex fd-column" height="calc(100vh - 340px)" style={{ overflowY: 'hidden' }}>
        {tableHead()}
        {Array.from({ length: 10 }).map((_, i) => tableRow(i))}
        {pagingRow()}
      </Container>
    </Container>
  );
};

export default TableListDenseSkeletonLoader;
